import { baseApi, Tag } from './base'
import { CreateSpecialityOptionDto, SpecialityOption, UpdateSpecialityOptionDto } from '../models/speciality-option.model'
import { SearchRequest } from '../types/request'

export const specialityOptionApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    createSpecialityOption: builder.mutation<SpecialityOption, CreateSpecialityOptionDto>({
      query: (body) => ({ url: `/speciality-options`, method: 'POST', body }),
      invalidatesTags: [Tag.SPECIALITY_OPTION],
    }),
    getSpecialityOptions: builder.query<SpecialityOption[], SearchRequest>({
      query: (params) => ({ url: '/speciality-options', method: 'GET', params }),
      providesTags: [Tag.SPECIALITY_OPTION],
    }),
    updateSpecialityOption: builder.mutation<SpecialityOption, { id: string; changes: UpdateSpecialityOptionDto }>({
      query: ({ id, changes }) => ({ url: `/speciality-options/${id}`, method: 'PATCH', body: changes }),
      invalidatesTags: [Tag.SPECIALITY_OPTION],
    }),
    deleteSpecialityOption: builder.mutation<void, string>({
      query: (id) => ({ url: `/speciality-options/${id}`, method: 'DELETE' }),
      invalidatesTags: [Tag.SPECIALITY_OPTION],
    }),
  }),
  overrideExisting: false,
})
